import React from 'react'

import { Link, Icon } from './styles'

const WhatsappButton = () => (
  <Link href='https://wa.me/5511945335634?' target='_blank'>
    <Icon className='fa fa-whatsapp' />
  </Link>
)

export default WhatsappButton
